import { combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import welcomeReducer from '@/features/welcome/welcomeSlice'
import authReducer from '@/store/slices/authSlice'

// Storage interface signatures are kept verbose so TS infers the right shape;
// underscore-prefix args are intentionally unused.
/* eslint-disable @typescript-eslint/no-unused-vars */
const createNoopStorage = () => ({
  getItem(_key: string) {
    return Promise.resolve(null)
  },
  setItem(_key: string, value: string) {
    return Promise.resolve(value)
  },
  removeItem(_key: string) {
    return Promise.resolve()
  },
})
/* eslint-enable @typescript-eslint/no-unused-vars */

type PersistStorage = {
  getItem(key: string): Promise<string | null> | string | null
  setItem(key: string, value: string): Promise<void> | void
  removeItem(key: string): Promise<void> | void
}

const resolvedStorage = storage as PersistStorage & { default?: PersistStorage }
const storageEngine =
  typeof window !== 'undefined'
    ? (resolvedStorage.default ?? resolvedStorage)
    : createNoopStorage()

const persistConfig = {
  key: 'root',
  storage: storageEngine,
  whitelist: ['welcome'],
}

const rootReducer = combineReducers({
  welcome: welcomeReducer,
  auth: authReducer,
})

export const persistedReducer = persistReducer(persistConfig, rootReducer)
export type RootReducerState = ReturnType<typeof rootReducer>
